export default "__VITE_ASSET__DTqkRm2x__"